import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WidgetsService {

  constructor() { }

  getWidgetTranslationsFormatedData(data, form, widgetId, type){
    let formatedData = {}
    switch(type){
      case 'billboardImage':{
        let { url, linkURL, altTitle } = form
        formatedData = {
          [data.selectedLanguage+'.'+widgetId+'.url']: url ? url : undefined,
          [data.selectedLanguage+'.'+widgetId+'.linkURL']: linkURL ? linkURL : undefined,
          [data.selectedLanguage+'.'+widgetId+'.altTitle']: altTitle ? altTitle : undefined,
        }
        break;
      }

      case 'billboardVideo':{
        let { url, altTitle} = form
        formatedData = {
          [data.selectedLanguage+'.'+widgetId+'.url']: url ? url : undefined,
          [data.selectedLanguage+'.'+widgetId+'.altTitle']: altTitle ? altTitle : undefined
        }
        break;
      }

      case 'callToAction':{
        let { imageUrl, altTitle} = form
        formatedData = {
          [data.selectedLanguage+'.'+widgetId+'.imageUrl']: imageUrl ? imageUrl : undefined,
          [data.selectedLanguage+'.'+widgetId+'.altTitle']: altTitle ? altTitle : undefined,
        }
        break;
      }

      case 'image':{
        let {title, subtitle, url, linkURL, altTitle} = form
        formatedData = {
          [data.selectedLanguage+'.'+widgetId+'.title']: title ? title : undefined,
          [data.selectedLanguage+'.'+widgetId+'.subtitle']: subtitle ? subtitle : undefined,
          [data.selectedLanguage+'.'+widgetId+'.url']: url ? url : undefined,
          [data.selectedLanguage+'.'+widgetId+'.linkURL']: linkURL ? linkURL : undefined,
          [data.selectedLanguage+'.'+widgetId+'.altTitle']: altTitle ? altTitle : undefined,
        }
        break;
      }

      case 'video':{
        let {title, subtitle, url, altTitle} = form
        formatedData = {
          [data.selectedLanguage+'.'+widgetId+'.title']: title ? title : undefined,
          [data.selectedLanguage+'.'+widgetId+'.subtitle']: subtitle ? subtitle : undefined,
          [data.selectedLanguage+'.'+widgetId+'.url']: url ? url : undefined,
          [data.selectedLanguage+'.'+widgetId+'.altTitle']: altTitle ? altTitle : undefined,
        }
        break;
      }

      case 'splashVideo':{
        let {url, altTitle} = form
        formatedData = {
          [data.selectedLanguage+'.'+widgetId+'.url']: url ? url : undefined,
          [data.selectedLanguage+'.'+widgetId+'.altTitle']: altTitle ? altTitle : undefined
        }
        break;
      }

      case 'countdown':{
        let {expiredMessage} = form
        formatedData = {
          [data.selectedLanguage+'.'+widgetId+'.expiredMessage']: expiredMessage ? expiredMessage : undefined,
        }
        break;
      }

      case 'images':{
        let {title, subtitle, images} = form
        formatedData = {
          [data.selectedLanguage+'.'+widgetId+'.title']: title ? title : undefined,
          [data.selectedLanguage+'.'+widgetId+'.subtitle']: subtitle ? subtitle : undefined,
        }

        images.forEach((image, index) => {
          const oldImage =data.defaultLanguageWidgetData?.images[index]

          if( oldImage?.url != image.url)// image.url &&
            formatedData[data.selectedLanguage + '.' + widgetId + '_' + image.id + '.url'] = image.url ? image.url : undefined
          else
          formatedData[data.selectedLanguage + '.' + widgetId + '_' + image.id + '.url'] =  undefined

          if(  oldImage?.title != image.title)//image.title &&
            formatedData[data.selectedLanguage + '.' + widgetId + '_' + image.id +'.title'] = image.title ? image.title : undefined
          else
          formatedData[data.selectedLanguage + '.' + widgetId + '_' + image.id +'.title'] = undefined

          if(  oldImage?.linkURL != image.linkURL) //image.linkURL &&
            formatedData[data.selectedLanguage + '.' + widgetId + '_' + image.id +'.linkURL'] = image.linkURL ? image.linkURL : undefined
          else
           formatedData[data.selectedLanguage + '.' + widgetId + '_' + image.id +'.linkURL'] =  undefined

          if(  oldImage?.altTitle != image.altTitle) //image.altTitle &&
            formatedData[data.selectedLanguage + '.' + widgetId + '_' + image.id +'.altTitle'] = image.altTitle ? image.altTitle : undefined
          else
           formatedData[data.selectedLanguage + '.' + widgetId + '_' + image.id +'.altTitle'] =  undefined
        });
        break;
      }

      case 'productRegistration':{
        let {registeredText, unregisteredText, altTitle} = form
        formatedData = {
          [data.selectedLanguage+'.'+widgetId+'_registered.text']: registeredText ? registeredText : undefined,
          [data.selectedLanguage+'.'+widgetId+'_unregistered.text']: unregisteredText ? unregisteredText : undefined,
          [data.selectedLanguage+'.'+widgetId+'_image.altTitle']: altTitle ? altTitle : undefined
        }

        break;
      }

      case 'form':{
        let {title, subtitle, sections,submitTitle, submitAgainTitle, successMessage} = form
        formatedData = {
          [data.selectedLanguage+'.'+widgetId+'.title']: title ? title : undefined,
          [data.selectedLanguage+'.'+widgetId+'.subtitle']: subtitle ? subtitle : undefined,
          [data.selectedLanguage+'.'+widgetId+'.submitTitle']: submitTitle ? submitTitle : undefined,
          [data.selectedLanguage+'.'+widgetId+'.submitAgainTitle']: submitAgainTitle ? submitAgainTitle : undefined,
          [data.selectedLanguage+'.'+widgetId+'.successMessage']: successMessage ? successMessage : undefined,
        }

        sections?.forEach((section, index) => {
          const oldSection = data.defaultLanguageWidgetData?.sections[index]

          if( oldSection?.title != section.title)
            formatedData[data.selectedLanguage + '.' + widgetId + '_' + section.id +'.title'] = section.title ? section.title : undefined
          else
            formatedData[data.selectedLanguage + '.' + widgetId + '_' + section.id +'.title'] =  undefined

          section?.fields.forEach((field, fieldIndex) => {

            if(field.type == "options"){
              field.options?.forEach((option, optionIndex) => {
              if( oldSection?.fields[fieldIndex]?.options[optionIndex]?.title != option?.title)
                formatedData[data.selectedLanguage + '.' + widgetId + '_' + section.id + '_' + field.id +'.options_' + option.id + '.title'] = option.title ? option.title : undefined
              });
            }
            if( oldSection?.fields[fieldIndex]?.title != field.title)
            formatedData[data.selectedLanguage + '.' + widgetId + '_' + section.id + '_' + field.id +'.title'] = field.title ? field.title : undefined
            else
            formatedData[data.selectedLanguage + '.' + widgetId + '_' + section.id + '_' + field.id +'.title'] = undefined
          });
        });
        break;
      }

      case 'composed':{
        let {title, subtitle, content} = form
        formatedData = {
          [data.selectedLanguage+'.'+widgetId+'.title']: title ? title : undefined,
          [data.selectedLanguage+'.'+widgetId+'.subtitle']: subtitle ? subtitle : undefined,
        }

        content.forEach((content, index) => {
          this.getTranslationsOfContent(content, formatedData, widgetId, data)
        });
        break;
      }

      case 'buttons':{
        const { buttons } = form

        buttons.forEach( (button, index)=> {
          let {title, url} = button
          formatedData[data.selectedLanguage + '.' + widgetId + '_' + button.id + '.title'] = title ? title : undefined,
          formatedData[data.selectedLanguage + '.' + widgetId + '_' + button.id + '.url'] = url ? url : undefined
        })

        break;
      }

      case 'text':{
        let {title, subtitle, altTitle, text} = form
        formatedData = {
          [data.selectedLanguage+'.'+widgetId+'.title']: title ? title : undefined,
          [data.selectedLanguage+'.'+widgetId+'.subtitle']: subtitle ? subtitle : undefined,
          [data.selectedLanguage+'.'+widgetId+'_image.altTitle']: altTitle ? altTitle : undefined,
          [data.selectedLanguage+'.'+widgetId+'.text']: text ? text : undefined,
        }
        break;
      }

      case 'annotatedMap':{
        let {title, subtitle, annotations} = form
        formatedData = {
          [data.selectedLanguage+'.'+widgetId+'.title']: title ? title : undefined,
          [data.selectedLanguage+'.'+widgetId+'.subtitle']: subtitle ? subtitle : undefined,
        }

        annotations.forEach((annotation, index) => {
          if(annotation.dynamic){
            formatedData[data.selectedLanguage + '.' + widgetId + '_' + annotation.id +'.properties.title'] = annotation?.properties?.title ? annotation.properties.title :undefined
            formatedData[data.selectedLanguage + '.' + widgetId + '_' + annotation.id +'.properties.subtitle'] = annotation?.properties?.subtitle ? annotation.properties.subtitle :undefined
            formatedData[data.selectedLanguage + '.' + widgetId + '_' + annotation.id +'.properties.linkURL'] = annotation?.properties?.linkURL ? annotation.properties.linkURL :undefined
          }else{
            formatedData[data.selectedLanguage + '.' + widgetId + '_' + annotation.id +'.title'] = annotation.title ? annotation.title :undefined
            formatedData[data.selectedLanguage + '.' + widgetId + '_' + annotation.id +'.subtitle'] = annotation.subtitle ? annotation.subtitle :undefined
            formatedData[data.selectedLanguage + '.' + widgetId + '_' + annotation.id +'.linkURL'] = annotation.linkURL ? annotation.linkURL :undefined
          }
        });
        break;
      }
    }

    return formatedData
  }

  getTranslationsOfContent(element ,formatedData, widgetId, data){
    if(element.type == 'zstack' || element.type == 'hstack' || element.type == 'vstack'){
      const children = element.children
      children.forEach(child => {
        this.getTranslationsOfContent(child, formatedData, widgetId,data)
      });
    }

    if(element.type == 'text'){
      const oldNode = this.searchNestedArray(data.defaultLanguageWidgetData.content, 'id', element.id)
      // if( oldNode.attributes?.text != element.attributes?.text){
        formatedData[data.selectedLanguage + '.' + widgetId + '_' + element.id +'_attributes.text'] = element.attributes.text ? element.attributes.text : undefined

      if( oldNode.attributes?.text == element.attributes?.text)
        formatedData[data.selectedLanguage + '.' + widgetId + '_' + element.id +'_attributes.text'] = undefined
    }

  }

  searchNestedArray(array: any[], field: string, value: any): any | null {
    for (const item of array) {
      if (item[field] === value)
        return item;

      // Recursively search in nested arrays (if they exist)
      for (const key in item) {
        if (Array.isArray(item[key])) {
          const result = this.searchNestedArray(item[key], field, value);
          if (result)
            return result;
        }
      }
    }
  }
}
